import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  MenuProps,
  styled,
} from "@mui/material";

const StyledMenuList = styled(MenuList)(() => ({
  padding: 0,
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  paddingBlock: "10px",
}));

const StyledListItemIcon = styled(ListItemIcon)(() => ({
  color: "inherit",
}));

interface IMenuItem {
  icon: React.JSX.Element;
  title: string;
  isDisabled?: boolean;
  className?: string;
  action: () => void | Promise<void>;
}

interface IProps extends MenuProps {
  menuItems: IMenuItem[];
}

const ActionsMenu = ({ menuItems, ...restProps }: IProps) => {
  return (
    <Menu {...restProps}>
      <StyledMenuList>
        {menuItems.map(({ icon, title, isDisabled, className, action }) => (
          <StyledMenuItem
            key={title}
            disabled={isDisabled}
            className={className}
            onClick={action}
          >
            <StyledListItemIcon>{icon}</StyledListItemIcon>
            <ListItemText>{title}</ListItemText>
          </StyledMenuItem>
        ))}
      </StyledMenuList>
    </Menu>
  );
};

export default ActionsMenu;
